module.exports = "/images/connector.jpg?c1f6590d5c7aaff7cecd1830521c1117";